import { Typography, styled } from '@mui/material';

const DateLabel = styled(Typography)`
  text-align: center;
  margin-top: -24px;
`;

export default DateLabel;
